export const SET_TRIGGERS_TABLE_THEMATICS = 'SET_TRIGGERS_TABLE_THEMATICS';

export const setTriggersTableThematics = thematics => {
  return {
    type: SET_TRIGGERS_TABLE_THEMATICS,
    data: thematics,
  };
};
